export default __webpack_public_path__ + "static/media/IcArrowLeftInactive.bf15c416.svg";